import { BinaryOption } from '../../../../../enums';
export const getOverdDueTasks = () => {
    return [
        { name: 'Show Only', value: BinaryOption.TRUE },
        { name: 'Exclude', value: BinaryOption.FALSE },
    ];
};
